export const ESF = [
  { label: 'ESF 1', value: 1 },
  { label: 'ESF 2', value: 2 },
  { label: 'ESF 3', value: 3 },
  { label: 'ESF 4', value: 4 },
  { label: 'ESF 5', value: 5 },
  { label: 'ESF 6', value: 6 },
  { label: 'ESF 7', value: 7 },
  { label: 'ESF 8', value: 8 },
  { label: 'ESF 9', value: 9 },
  { label: 'ESF 10', value: 10 },
  { label: 'ESF 11', value: 11 },
  { label: 'ESF 12', value: 12 },
  { label: 'ESF 13', value: 13 },
  { label: 'ESF 14', value: 14 },
  { label: 'ESF 15', value: 15 },
  { label: 'ESF 16', value: 16 },
  { label: 'ESF 17', value: 17 },
  { label: 'ESF 18', value: 18 },
  { label: 'ESF 19', value: 19 },
  { label: 'ESF 20', value: 20 },
  { label: 'ESF 21', value: 21 },
  { label: 'ESF 22', value: 22 },
  { label: 'ESF 23', value: 23 },
  { label: 'ESF 24', value: 24 },
  { label: 'ESF 25', value: 25 },
]
